import { Model } from '@appstrax/services/database';
import { ProjectUserRoles } from '@models';

export type InviteStatus = 'pending' | 'accepted' | 'declined' | 'cancelled';

export class ProjectInvite extends Model {
  public projectId: string = '';
  public fromUserId: string = '';
  public toUserId: string = '';
  public role: ProjectUserRoles = ProjectUserRoles.MEMBER;
  public status: InviteStatus = 'pending';
  public timestamp: number = Date.now();
  public note?: string;
}

